<template>
  <img class="image" :class="{ 'image--mini': miniSize }" :src="imageSrc" :alt="goal.title" :title="goal.description" />
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import type { CompanyGoal } from "@/models/companyGoal";
import { imageDefaultForCourses } from "@/constants/urls";
import useMeGoalsService from "@/services/useMeGoalsService";

const { getGoalPicture } = useMeGoalsService();

interface Props {
  goal: CompanyGoal;
  miniSize?: boolean;
}
const props = defineProps<Props>();

const imageSrc = ref<string>(imageDefaultForCourses);
onMounted(async () => {
  if (props.goal.picture?.fileName) {
    try {
      const blob = await getGoalPicture(props.goal.id);
      imageSrc.value = URL.createObjectURL(blob);
      console.log(imageSrc.value);
    } catch {
      imageSrc.value = imageDefaultForCourses;
    }
  }
});

</script>

<style lang="scss" scoped>
.image {
  height: 280px;
  width: 100%;
  object-fit: cover;
  &--mini {
    height: 252px;
  }
}
</style>
